import script from "./transfer-record.vue?vue&type=script&setup=true&lang=js"
export * from "./transfer-record.vue?vue&type=script&setup=true&lang=js"

import "./transfer-record.vue?vue&type=style&index=0&id=49673b28&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/builds/jolly88-complex/frontend/affiliate-static-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49673b28"]])

export default __exports__